import { httpClient } from '@/lib/httpClient';

export enum ExportStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  FAILED = 'failed',
  WAITING = 'waiting',
}

export interface VoiceToneExport {
  jobId: string;
  customerId: number;
  promptName: string;
  version: string;
  status: ExportStatus;
  fileKey: string;
  fileUrl: string;
  progress?: number;
  finishedAt?: string;
  createdAt: string;
  error?: string;
}

export interface CreateExportDto {
  customerId: number;
  promptName: string;
  version: string;
}

export interface CreateExportResponseDto {
  jobId: string;
  customerId: number;
  promptName: string;
  version: string;
  success: boolean;
  message: string;
}

class VoiceToneService {
  constructor() {}

  async createExport(createExportDto: CreateExportDto) {
    const response = await httpClient.post<CreateExportResponseDto>(
      '/v1/voice-tone/export',
      null,
      {
        params: {
          customerId: createExportDto.customerId,
          promptName: createExportDto.promptName,
          version: createExportDto.version,
        },
      },
    );
    return response.data;
  }

  async listExports() {
    const response = await httpClient.get<VoiceToneExport[]>(
      '/v1/voice-tone/exports',
    );
    return response.data;
  }

  async getExportByCustomerId(customerId: number) {
    const response = await httpClient.get<VoiceToneExport[]>(
      `/v1/voice-tone/export/customer/${customerId}`,
    );
    return response.data;
  }

  async getExportStatus(jobId: string) {
    const response = await httpClient.get<VoiceToneExport>(
      `/v1/voice-tone/export/${jobId}`,
    );
    return response.data.status;
  }
}

export const voiceToneService = new VoiceToneService();
